import { IMAGE_URL, PUBLIC_ROOT_URL } from '../config';

let webp = null;
let avif = null;

const detectWebpSupport = () => {
    const elem = document.createElement('canvas');
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!(elem.getContext && elem.getContext('2d'))) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
};

const detectAvifSupport = () => new Promise((resolve) => {
    const image = new Image();
    image.onerror = () => resolve(false);
    image.onload = () => resolve(true);
    image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
});

detectAvifSupport().then((v) => avif = v);

const canUseWebp = () => {
    if (webp === null) {
        webp = detectWebpSupport();
    }
    return webp;
};

export const getPictureLink = (url = '', args = {}, alpha = false) => {
    if (!url) {
        return null;
    }

    if (!IMAGE_URL) {
        return url;
    }

    const output = canUseWebp() ? 'webp' : alpha ? 'png' : 'jpg';
    const q = output === 'webp' ? 60 : output === 'jpg' ? 75 : 100;

    const params = new URLSearchParams({
        ...args,
        ...(args.w ? { w: Math.round(args.w) } : {}),
        ...(args.h ? { h: Math.round(args.h) } : {}),
        ...(url ? { url } : {}),
        ...(alpha === false ? { bg: '#FFF' } : {}),
        output,
        q,
        il: '',
        l: '',
        t: 'fit',
        default: `${PUBLIC_ROOT_URL}blank.gif`,
    }).toString();

    return `${IMAGE_URL}?${params}`;
};

export const chooseBestImage = (imgs = []) => {
    const cleanPath = (path) => path?.toLowerCase()?.split('?')?.[0];

    if (!Array.isArray(imgs)) {
        return null;
    }

    if (avif) {
        const tmp = imgs.find(e => cleanPath(e).endsWith('.avif'));
        if (tmp) {
            return tmp;
        }
    }
    if (webp || canUseWebp()) {
        const tmp = imgs.find(e => cleanPath(e).endsWith('.webp'));
        if (tmp) {
            return tmp;
        }
    }
    const tmp = imgs.find(e => !cleanPath(e).endsWith('.webp') && !cleanPath(e).endsWith('.avif'));
    if (tmp) {
        return tmp;
    }
    return tmp[0];
}